module.exports = __webpack_public_path__ + "static/media/222-Sturz-Ansprechen-Teil2-Milo_ID_28.feca5508.mp3";